import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import * as rp from 'request-promise';
import Spinner from 'react-bootstrap/Spinner'
import { updateAccountInfo } from 'store/actions/userActions'
import PixelSettingsSection from 'components/PixelSettingsSection';
const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function IntegrationCard({title, description, connected, onConnect, onDisconnect, loaded, viewMore, disabled}) {
    return (
        <div className="card mb-5">
            <div className="card-body">
                <h5 className="card-title">{title}</h5>
                <p className="card-text">{description}</p>
                <div className="d-flex">
                    <button onClick={onConnect} disabled={!loaded || connected || disabled} type="button" className="btn btn-primary">
                        <span>{connected ? "Connected" : "Connect"}</span>
                        {!loaded && (
                            <Spinner
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden={true}
                                className="ml-2"
                            />
                        )}
                    </button>
                    {connected && onDisconnect && (
                        <button onClick={onDisconnect} type="button" className="btn btn-link">
                            <span>Disconnect</span>
                            {!loaded && (
                                <Spinner
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden={true}
                                    className="ml-2"
                                />
                            )}
                        </button>
                    )}
                    {connected && viewMore && (
                        // <a target="_blank" href={viewMore}>View Dashboard</a>
                        <button onClick={() => {
                            window.open(
                                viewMore,
                                '_blank' // <- This is what makes it open in a new window.
                              );
                        }} type="button" className="btn btn-link">
                            <span>View Dashboard</span>
                            {/* {!loaded && (
                                <Spinner
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden={true}
                                    className="ml-2"
                                />
                            )} */}
                        </button>
                    )}
                </div>
                
            </div>
        </div>
    )
}

function IntegrationsSection(props) {

    const dispatch = useDispatch()
    const user = useSelector(state => state.instructor.instructor);
    const isSaving = useSelector(state => state.user.saving)

    const handleFormSubmission = (data) => {
        dispatch(updateAccountInfo(data))
    }

    ////////////////////////
    // Zapier
    ////////////////////////

    const [loadedZapier, setLoadedZapier] = useState(false);
    const [zapierConnected, setZapierConnected] = useState(false);

    function handleZapierClick(e) {
        e.preventDefault()
        // if (!user.email || user.email === "") {
        //     // alert(`Must have valid email address:\n${instructor.email} is not valid`)
        //     return;
        // }

        // const options = {
        //     method: 'GET',
        //     // uri: `https://us-central1-sutra-prod.cloudfunctions.net/connect/state?userId=${instructor.platformID}`,
        //     uri: `${API_BASE_URL}/connect/state?userId=${user.platformID}`,
        //     json: true
        // }

        // rp(options)
        //     .then( response => {
        //         const state = response.state;
        //         const link = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENT_ID}&suggested_capabilities[]=transfers&scope=read_write&state=${state}&stripe_user[email]=${user.email}`;
        //         window.location.assign(link)
        //     })
        //     .catch( err => {
        //         alert("received Err :" + err)
        //     })
    }

    ////////////////////////
    // STRIPE
    ////////////////////////

    const [loadedStripe, setLoadedStripe] = useState(false);
    const [stripeConnected, setStripeConnected] = useState(false);

    function handleStripeClick(e) {
        e.preventDefault()
        if (!user.email || user.email === "") {
            // alert(`Must have valid email address:\n${instructor.email} is not valid`)
            return;
        }

        const options = {
            method: 'GET',
            // uri: `https://us-central1-sutra-prod.cloudfunctions.net/connect/state?userId=${instructor.platformID}`,
            uri: `${API_BASE_URL}/connect/state?userId=${user.platformID}`,
            json: true
        }

        rp(options)
            .then( response => {
                const state = response.state;
                const link = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENT_ID}&suggested_capabilities[]=transfers&scope=read_write&state=${state}&stripe_user[email]=${user.email}`;
                window.location.assign(link)
            })
            .catch( err => {
                alert("received Err :" + err)
            })
    }

    ////////////////////////
    // Zoom
    ////////////////////////

    const [loadedZoom, setLoadedZoom] = useState(false);
    const [zoomConnected, setZoomConnected] = useState(false);

    function handleZoomDisconnect(e) {
        e.preventDefault()
        setLoadedZoom(false);
        if (!user.email || user.email === "") {
            // alert(`Must have valid email address:\n${instructor.email} is not valid`)
            return;
        }

        const options = {
            method: 'GET',
            uri: `${API_BASE_URL}/zoom/deactivate?userId=${user.platformID}`,
            json: true
        }

        rp(options)
            .then( (_) => {
                setZoomConnected(false);
                setLoadedZoom(true);
            })
            .catch( err => {
                alert("Received Error: " + err)
                setZoomConnected(true);
                setLoadedZoom(true);
            })
    }

    function handleZoomClick(e) {
        e.preventDefault()
        if (!user.email || user.email === "") {
            // alert(`Must have valid email address:\n${instructor.email} is not valid`)
            return;
        }

        const options = {
            method: 'GET',
            uri: `${API_BASE_URL}/zoom/oauth?userId=${user.platformID}&clientRedirect=${window.location.href}`,
            json: true
        }

        rp(options)
            .then( response => {
                // const state = response.state;
                // const link = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENT_ID}&suggested_capabilities[]=transfers&scope=read_write&state=${state}&stripe_user[email]=${instructor.email}`;
                // window.location.assign(link)
                console.log(response)
                const link = response.link;
                window.location.assign(link)
            })
            .catch( err => {
                alert("received Err :" + err)
            })
    }

    ////////////////////////
    // Other
    ////////////////////////

    useEffect(() => {
        if (!user || !user.platformID) {
            return;
        }

        // Stripe
        const stripeRequest = {
            method: 'GET',
            // uri: `https://us-central1-sutra-prod.cloudfunctions.net/connect/account?userId=${instructor.platformID}`,
            uri: `${API_BASE_URL}/connect/account?userId=${user.platformID}`,
            json: true
        }
        rp(stripeRequest)
            .then( response => {
                console.log("stripe response: ", response)
                const success = response.success;
                const account_exists = response.data?.exists
                setStripeConnected(success && account_exists);
                setLoadedStripe(true);
            })
            .catch( err => {
                // alert("received Err :" + err)
                setStripeConnected(false);
                setLoadedStripe(true);
            })

        // Zoom

        const zoomRequest = {
            method: 'GET',
            uri: `${API_BASE_URL}/zoom/account?userId=${user.platformID}`,
            json: true
        }
        rp(zoomRequest)
            .then( response => {
                // alert("received response :" + response)
                const account_exists = response.success;
                setZoomConnected(account_exists);
                setLoadedZoom(true);
                
            })
            .catch( err => {
                // alert("Received Error:" + err)
                // console.log()
                setZoomConnected(false);
                setLoadedZoom(true);
            })

        // Zaper

        // const zapierRequest = {
        //     method: 'GET',
        //     uri: `${API_BASE_URL}/zoom/account?userId=${user.platformID}`,
        //     json: true
        // }
        // rp(zapierRequest)
        //     .then( response => {
        //         // alert("received response :" + response)
        //         const account_exists = response.success;
        //         setZapierConnected(account_exists);
        //         setLoadedZapier(true);
                
        //     })
        //     .catch( err => {
        //         // alert("Received Error:" + err)
        //         // console.log()
        //         setZapierConnected(false);
        //         setLoadedZapier(true);
        //     })
    }, [user]);

    return (
        <>
        <IntegrationCard 
            title="Zoom"
            description="Create new meetings automatically every time you schedule a class."
            connected={zoomConnected}
            loaded={loadedZoom}
            onConnect={handleZoomClick}
            onDisconnect={handleZoomDisconnect}
        />
        <IntegrationCard 
            title="Stripe"
            description="Connect your account with Stripe to receive earnings from your students."
            connected={stripeConnected}
            loaded={loadedStripe}
            onConnect={handleStripeClick}
            viewMore={`https://dashboard.stripe.com/dashboard`}
            // onDisconnect={() => console.log("Disconnect stripe")}
        />

        <IntegrationCard 
            title="Zapier"
            description={(
                <span>In Beta -- select partners only. Contact <a target="_blank" href="mailto:josh@sutra.fit">josh@sutra.fit</a> for special access</span>
            )}
            disabled={true}
            // connected={zapierConnected}
            connected={false}
            // loaded={loadedZapier}
            loaded={true}
            onConnect={handleZapierClick}
            // viewMore={`https://dashboard.stripe.com/dashboard`}
            // onDisconnect={() => console.log("Disconnect stripe")}
        />

        {user && user.platformID && (
            <PixelSettingsSection
            user={user}
            handleFormSubmission={handleFormSubmission}
            isSaving={isSaving}
            />

        )}
        </>
    )

}

export default IntegrationsSection;